import { useDispatch } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { ColumnIcon } from 'foundations-assets/icons/components/ColumnIcon';
// @ts-ignore not typed
import { getEmptyImage } from 'react-dnd-ipeui-backend';
import HorizontalEdgeToolbar from 'layout-dnd-components/DndToolbar/HorizontalEdgeToolbar';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { buildDeleteAction, buildDuplicateAction, buildEditStylesAction, buildHideOnMobileAction, useGridToggleNodeVisibilityOnThisBreakpoint } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BaseVerticalStackToolbar({
  toolbarInfo,
  active,
  responsiveSize,
  isDraggable = true,
  isInNonDefaultBreakpointMode,
  connectDragSource,
  connectDragPreview,
  onHandleMouseDown,
  onDropdownOpenChange
}) {
  const dispatch = useDispatch();
  const toggleNodeVisibilityOnThisBreakpoint = useGridToggleNodeVisibilityOnThisBreakpoint(toolbarInfo);
  useEffect(() => {
    if (!connectDragPreview) {
      return;
    }
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }, [connectDragPreview]);
  const columnActions = useMemo(() => {
    const actions = [buildEditStylesAction('column', dispatch, toolbarInfo, /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.column.editStyles"
    }))];
    if (!isInNonDefaultBreakpointMode) {
      actions.push(buildDuplicateAction('column', dispatch, toolbarInfo, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.column.clone"
      })), buildDeleteAction('column', dispatch, toolbarInfo, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.column.delete"
      })));
    } else {
      actions.push(buildHideOnMobileAction('column', /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.column.hide"
      }), toggleNodeVisibilityOnThisBreakpoint));
    }
    return actions;
  }, [dispatch, toolbarInfo, isInNonDefaultBreakpointMode, toggleNodeVisibilityOnThisBreakpoint]);
  const styleActionIndex = columnActions.findIndex(action => action.id === 'column-styles');
  const iconClickHandler = styleActionIndex === -1 || columnActions[styleActionIndex].disabled ? undefined : columnActions[styleActionIndex].callback;
  return /*#__PURE__*/_jsx(HorizontalEdgeToolbar, {
    active: active,
    icon: ColumnIcon,
    actions: columnActions,
    position: "absolute",
    zIndex: 5,
    insetInlineStart: `${Math.round((toolbarInfo === null || toolbarInfo === void 0 ? void 0 : toolbarInfo.left) || 0)}px`,
    insetBlockStart: `${Math.round((toolbarInfo === null || toolbarInfo === void 0 ? void 0 : toolbarInfo.top) || 0)}px`,
    handleTooltipPlacement: "top right",
    responsiveSize: responsiveSize,
    variant: "primary",
    handleTooltip: I18n.text('inpage.tile.column.label'),
    onDropdownOpenChange: onDropdownOpenChange,
    onHandleMouseDown: onHandleMouseDown,
    onHandleClick: iconClickHandler,
    handleButtonStyles: {
      cursor: isDraggable ? 'move' : 'default'
    },
    handleButtonRef: handleButtonElement => {
      if (handleButtonElement && connectDragSource) {
        connectDragSource(handleButtonElement);
      }
    }
  });
}